export default __webpack_public_path__ + "66a4014b126cb90831a25cfc8c84b79d.jpg";